import Vue from 'vue'
import Router from 'vue-router'


//运输 业务/////////////////

const order_fh = () => import("@/components/ys_fh/order_fh"); //订单-发货


const trans_fh = () => import("@/components/ys_fh/trans_fh"); //调度单
const transapply_fh = () => import("@/components/ys_fh/trans_apply_fh"); //运输费用申请
const applysj = () => import("@/components/ys_fh/apply_sj"); //司机费用申请
const applyjw = () => import("@/components/ys_business/apply_jw"); //就位费用申请
const applykl = () => import("@/components/ys_business/apply_kl"); //堪路费用申请

const transback = () => import("@/components/ys_business/trans_back");	//回单
const bumpinfo = () => import("@/components/ys_business/bump");	//冲撞仪
const bumptrans = () => import("@/components/ys_business/bump_trans");	//冲撞仪路程记录


Vue.use(Router)

//运输业务//////////////////////////
export default [
	{
		name: "order_fh",
		path: "/order_fh",
		component: order_fh,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "订单发货"
		}
	},	
	{
		name: "trans_fh",
		path: "/trans_fh",
		component: trans_fh,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "调度单"
		}
	},
	{
		name: "transapply_fh",
		path: "/transapply_fh",
		component: transapply_fh,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "运输费用申请"
		}
	},
	{
		name: "applysj_fh",
		path: "/applysj_fh",
		component: applysj,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "司机报销申请"
		}
	},
	{
		name: "applyjw",
		path: "/applyjw",
		component: applyjw,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "就位费用申请"
		}
	},
	{
		name: "applykl",
		path: "/applykl",
		component: applykl,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "堪路费用申请"
		}
	},
	{
		name: "transback",
		path: "/transback",
		component: transback,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "回单"
		}
	},
	{
		name: "bumpinfo",
		path: "/bumpinfo",
		component: bumpinfo,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "冲撞仪"
		}
	},
	{
		name: "bumptrans",
		path: "/bumptrans",
		component: bumptrans,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "冲撞仪路程记录"
		}
	}


]
